import { BASE_PATH, CONTACT_US_FLATPAGE_URL, WHOLESALE_ROUTES } from './SPA/urls'

export const IS_DEV = process.env.NODE_ENV === 'development' || process.env.LOCAL
export const CLIENT_URL = IS_DEV ? 'http://localhost:9000' : process.env.CLIENT_URL
export const DOMAIN = process.env.DOMAIN
export const TRANSLOADIT_API_KEY = IS_DEV ? process.env.DEV_TRANSLOADIT_API_KEY : process.env.TRANSLOADIT_API_KEY
export const TRANSLOADIT_TEMPLATE_ID = IS_DEV
  ? process.env.DEV_TRANSLOADIT_TEMPLATE_ID
  : process.env.TRANSLOADIT_TEMPLATE_ID

export const SITE_RECAPTCHA_KEY = IS_DEV ? process.env.DEV_RECAPTCHA_PUBLIC_KEY : process.env.RECAPTCHA_PUBLIC_KEY
export const GTM_ID = IS_DEV ? process.env.DEV_GTM_ID : process.env.GTM_ID
export const INSTAGRAM_URL = 'https://www.instagram.com/craftntools/'
export const GOOGLE_MERCHANT_ID = IS_DEV ? null : process.env.GOOGLE_MERCHANT_ID
export const SITE_NAME = 'Craft and Tools'
export const SHORT_SITE_NAME = 'CNT'

export const DEFAULT_CURRENCY = 'USD'

export const VALIDATION_MESSAGES = {
  requiredField: 'This value is required',
  email: 'Please enter a valid address',
  url: 'Please enter a valid URL',
  mustChecked: 'Field must be checked',
  minValue: (val: number | string) => `Must be greater than or equal to ${val}`,
  maxValue: (val: number | string) => `Must be less than or equal to ${val}`,
  maxLength: (val: number | string) => `Must be at most ${val} characters`,
}

export const getWholesaleMenuLinks = (t: (key: string, defaultValue: string) => string) => [
  { url: WHOLESALE_ROUTES.HOME, title: t('wholesale.menu.home', 'Home') },
  { url: WHOLESALE_ROUTES.PRODUCTS, title: t('wholesale.menu.products', 'Products') },
  { url: WHOLESALE_ROUTES.TERMS, title: t('wholesale.menu.terms', 'Terms') },
  { url: BASE_PATH, title: t('wholesale.menu.mainWebsite', 'Main Website') },
]
export const getWholesaleCompanyMenuLinks = (t: (key: string, defaultValue: string) => string) => [
  { url: WHOLESALE_ROUTES.HOME, title: t('wholesale.menu.mainWebsite', 'Main Website') },
  { url: WHOLESALE_ROUTES.PRODUCTS, title: t('wholesale.menu.products', 'Products') },
  { url: WHOLESALE_ROUTES.TERMS, title: t('wholesale.menu.wholesaleTerms', 'Wholesale Terms') },
  { url: CONTACT_US_FLATPAGE_URL, title: t('wholesale.menu.contactUs', 'Contact Us') },
]

export const LOCAL_STORAGE_KEYS = {
  WHOLESALE_MODE: 'wholesaleMode',
  SEARCH_ACTIVE: 'isActiveSearch',
  CHECKOUT_ORDER_NOTES: 'checkoutOrderNotes',
  BECOME_WHOLESALE_PARTNER: 'becomeWholesalePartner',
  NOTIFICATIONS: 'notifications',
  PRODUCTS_COLLAPSE: 'productsCollapse',
  CURRENCY: 'currency',
}
export const COOKIE_NAMES = {
  CART: 'cart',
  LANGUAGE: 'django_language',
}
export const DEFAULT_LANGUAGE = 'en'
export const SNACKBAR_CONFIG = {
  SNACKBAR_AUTO_HIDE_DURATION: 10000,
  MAX_SNACK: 2,
}

export const FEATURES = {
  WHOLESALE: false,
  ADS: true,
}

export const MAX_WHOLESALE_PRODUCT_QTY = 99999
export const MAX_PRODUCT_QTY = 99999

export const HIDE_FILTERS = {
  BY_NUMBER: true,
}
